<template>
  <div class="home-drawings">
    <div class="system-status" v-if="showSystemStatus">
      {{ systemStatus }}
      <div v-if="speed" style="font-size:12pt; margin-top:-15px">{{ speed }}</div>
    </div>
    <div class="bird slider">
      <!-- <img src="../assets/bird-from-side-light.png" @click="squawk" /> -->
    </div>

    <div class="login-btn">
      <div v-if="!nUpcomingTrips && !nOngoingTrips && !nUpcomingJobs && !nOngoingJobs ">
        <a
          class="button is-primary is-rounded"
          v-if="!$store.getters.isLoggedIn"
          @click="loginOkay(null)"
        >{{ $t("login.login-take-ride") }}</a>
        <a
          class="button is-rounded is-link"
          :class="{ 'is-danger': hasOngoingCustomerTransaction}"
          v-else
        >
          <span @click="goToShop">{{ $t("login.order-food") }}</span>
        </a>
      </div>
      <div v-if="nOngoingTrips">
        <div style="height:30px" />
        <span
          class="button is-rounded is-warning ongoing"
          @click="goToTransport"
        >{{ $t("passenger.n-ongoing-trips", nOngoingTrips)}}</span>
      </div>
      <div v-if="nUpcomingTrips">
        <div style="height:30px" />
        <span
          class="button is-rounded is-warning"
          @click="goToTrips"
        >{{ $t("passenger.n-upcoming-trips", nUpcomingTrips)}}</span>
      </div>
      <div v-if="nOngoingJobs">
        <div style="height:30px" />
        <span
          class="button is-rounded is-primary ongoing"
          @click="goToTransport"
        >{{ $t("passenger.n-ongoing-jobs", nOngoingJobs)}}</span>
      </div>
      <div v-if="nUpcomingJobs">
        <div style="height:30px" />
        <span
          class="button is-rounded is-primary"
          @click="goToJobs"
        >{{ $t("passenger.n-upcoming-jobs", nUpcomingJobs)}}</span>
      </div>
      <div v-if="$store.getters.isDeliveryDispatcher">
        <div style="height:30px" />
        <span
          class="button is-rounded is-success"
          @click="dispatchDelivery"
        >{{ $t("home.delivery") }}</span>
      </div>
      <div v-if="$store.getters.isCommerceAgent">
        <div style="height:30px" />
        <span class="button is-rounded is-primary" @click="goToCommerce">{{ $t("home.commerce") }}</span>
      </div>
      <div v-if="$store.getters.isLogisticsAgent">
        <div style="height:30px" />
        <span
          class="button is-rounded is-dark"
          @click="goto('logistics_fleet')"
        >{{ $t("logistics.logistics") }}</span>
      </div>
    </div>

    <div class="vehicles-container" v-if="!screenOkay && isPortrait" @click="goToControlCentre">
      <img src="../assets/transport_menu_tourist.png" style="transform:scale(0.7)" />
      <img src="../assets/transport_menu_songthaew.png" style="transform:scale(0.9)" />
      <img src="../assets/transport_menu_siilor.png" style="transform:scale(0.7)" />
      <img src="../assets/transport_menu_van.png" style="transform:scale(0.7)" />
      <img src="../assets/transport_menu_moto.png" style="transform:scale(0.7)" />
      <img src="../assets/transport_menu_taxi.png" style="transform:scale(0.7)" />
    </div>

    <div v-if="isPortrait" @click="squawk">
      <!-- left arrow -->
      <div class="bottom-arrow" style="left: 5%;" v-if="screenOkay">
        <p class="callout">{{ $t("home.transport-callout") }}</p>
        <img src="../assets/arrow_transport.png" class="arrow" />
      </div>

      <!-- middle arrow -->
      <div class="bottom-arrow centered" v-if="screenOkay">
        <p class="callout">
          {{ $t("home.shops-callout") }}
          <br />
        </p>
        <img src="../assets/arrow_shop.png" class="arrow" />
      </div>

      <!-- right arrow -->
      <div class="bottom-arrow" style="right: 5%;" v-if="screenOkay">
        <p class="callout">{{ $t("home.profile-callout") }}</p>
        <img src="../assets/arrow_profile.png" class="arrow" />
      </div>
    </div>

    <!-- add widget arrow -->
    <!-- v-if="screenHeight > 680" -->
    <!-- <div style="position:absolute; left:25px; top:165px;" v-if="screenOkay && screenHeight > 680">
      <img src="../assets/arrow_shop.png" class="arrow arrow-widget" />
      <p class="callout">{{ $t("home.widgets-callout") }}</p>
    </div>-->

    <!-- <div style="position:absolute; left:105px; top:110px;">
      <img src="../assets/arrow_shop.png" class="arrow arrow-plus" />
    </div>-->
    <!-- <div
      style="position:absolute; left:65px; top:120px; text-align:left; font-size:0.9em;"
      class="callout"
    >{{ $t("home.add-shop-callout") }}</div>-->

    <!-- QR arrow -->
    <!-- v-if="showQR" -->
    <!-- <div style="position: absolute; right: 100px; top: 20px;"> -->
    <!-- <span
        v-if="showQR"
        style="position: relative; left: -20px; top: -20px;"
        class="callout"
    >{{ $t("home.qr-callout") }}</span>-->
    <!-- <img src="../assets/arrow_shop.png" class="arrow arrow-qr" /> -->
    <!-- <div style="position:absolute; left:115px; top:15px;">
      <img src="../assets/arrow_shop.png" class="arrow arrow-school" />
    </div>-->
    <!-- left:128px; -->

    <!-- <div
      style="position:absolute; left:82px; top:28px; text-align:left; font-size:0.9em;"
      class="callout"
    >
      {{ $t("home.food-1") }}
      <br />
      {{ $t("home.food-2") }}
    </div>-->

    <!-- add widgets button -->
    <!-- <div class="buttons" style="position: absolute; left: 20px; top: 120px">
      <button class="button wiggle" id="widget-btn" @click="addShop">
        <span class="icon">
          <i class="fa fa-plus" />
        </span>
      </button>
    </div>-->
  </div>
</template>

<script>
import { sounds } from "../functions.js";

export default {
  name: "HomeDrawings",
  // components: { WidgetWeather },
  data() {
    return {
      hideCallouts: false,
      bird: null,
      showSystemStatus: false,
      cycle: 0,
    };
  },
  computed: {
    isPortrait() {
      return !this.isTablet();
    },
    systemStatus() {
      if (this.$store.state.systemSpeed < 2000) return "🏎"; // fast
      if (this.$store.state.systemSpeed < 4000) return "🐎"; // fast
      return "🐌"; // slow
    },
    speed() {
      if (!navigator.connection) return null;
      return navigator.connection.downlink + " Mbps";
    },
    screenOkay() {
      var roles = this.$store.state.roles;
      if (roles && roles.length > 0) return false;
      if (this.hideCallouts) return false;
      if (window.innerHeight < 520) return false;
      return true;
    },
    screenHeight() {
      return window.innerHeight;
    },
    goToTransportBtn() {
      // if (this.$store.state.rideCount === 0) {
      //   return this.$t("login.claim-free-ride");
      // }
      return this.$t("login.take-a-ride");
    },
    hasOngoingCustomerTransaction() {
      if (this.$store.getters.getCustomerTransactions.length > 0) {
        return true;
      }
      return false;
    },
    showQR() {
      if (this.isIOSApp()) return false;
      return true;
    },
    qrCalloutText() {
      if (this.showQR()) return this.$t("home.qr-callout");
      return "New! Go to school service";
    },
    nOngoingTrips() {
      var ongoing = this.$store.getters.getCustomerTransactionsNotAlighted;
      if (!ongoing) return false;
      if (ongoing.length <= 0) return false;
      return { n: ongoing.length };
    },
    nUpcomingTrips() {
      var upcoming = this.$store.getters.getOngoingCustomerTransactions;
      if (!upcoming) return false;
      var ongoing = this.$store.getters.getCustomerTransactions;
      var nUpcoming = upcoming.length - ongoing.length;
      if (nUpcoming <= 0) return false;
      return { n: nUpcoming };
    },
    nOngoingJobs() {
      var ongoing = this.$store.getters.getWorkerTransactions;
      if (!ongoing) return false;
      if (ongoing.length <= 0) return false;
      return { n: ongoing.length };
    },
    nUpcomingJobs() {
      var upcoming = this.$store.getters.getOngoingWorkerTransactions;
      if (!upcoming) return false;
      var ongoing = this.$store.getters.getWorkerTransactions;
      var nUpcoming = upcoming.length - ongoing.length;
      if (nUpcoming <= 0) return false;
      return { n: nUpcoming };
    },
  },
  mounted() {
    this.startCycling();
    this.bird = this.$el.querySelector(".bird");
    // set env colors (green local, cyan staging)
    // if (process.env.VUE_APP_TITLE === "Local") {
    //   document.getElementById("widget-btn").style.backgroundColor = "lightgreen";
    // }

    // if (window.innerHeight < 620) {
    //   this.bird.classList.toggle("closed"); // hide bird if screen too small
    // }
    if (window.innerHeight < 600 || window.innerWidth < 360) {
      this.$el.querySelectorAll(".callout").forEach((callout) => {
        callout.classList.toggle("smaller");
      });
    }
  },
  deactivated() {
    this.hideCallouts = true;
  },
  methods: {
    startCycling() {
      var next = 0;
      setInterval(() => {
        if (this.cycle === 5) next = 0;
        else next = this.cycle + 1;
        this.cycle = -1;
        this.cycle = next;
        // setTimeout(() => (this.cycle = next), 700);
      }, 1500);
    },
    goToControlCentre() {
      if (this.isSuperUser()) {
        this.goto("/control");
      }
    },
    goToTrips() {
      this.$router.push("/profile?tab=trips&tab2=Upcoming");
    },
    goToJobs() {
      this.$router.push("/profile?tab=roles&tab2=Jobs");
    },
    dispatchDelivery() {
      this.updateRoles(false); // don't show loader
      var role = this.$store.getters.getDeliveryDispatcherRole;
      console.log("deliveryWorkflow", role.workflow);
      this.$router.push("/delivery").catch((err) => {
        console.error("push_delivery err:", err);
        location.reload();
      });
    },
    goToCommerce() {
      this.updateRoles(false); // don't show loader
      var role = this.$store.getters.getCommerceAgentRole;
      var page = "/commerce"; // default
      if (role.workflow.data.ui) {
        if (role.workflow.data.ui === "ecommerce") page = "/ecommerce";
      }
      this.goto(page);
      // this.$router.push("/commerce").catch(err => console.error("err", err));
    },
    squawk() {
      setTimeout(() => (this.showSystemStatus = true), 200);
      this.testPushNotification();
      this.hideCallouts = !this.hideCallouts;
      sounds("squawk");
      this.bird.classList.toggle("closed");
      setTimeout(() => {
        if (this.$store.state.region === "Bagan") sounds("mingalaba");
        else sounds("sawatdii");
        this.bird.classList.toggle("closed");
        this.showSystemStatus = false;
      }, 1500);
    },
    testPushNotification() {
      if (this.$store.state.user)
        this.sendPushNotification("🎉🦜ขอบคุณเพื่อนของฉัน🙏🏽🕺🏻", this.userID());
    },
    addShop() {
      var url = this.$t("shop.sign-up-form");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    addWidget() {
      this.$swal({
        title: this.$t("home.widget-modal-title"),
        text: this.$t("home.widget-modal-text"),
        confirmButtonText: this.$t("submit"),
        showCloseButton: true,
        input: "text",
        inputPlaceholder: this.$t("home.widget"),
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("sendEmail", { widget: result.value })
            .then((res) => this.console(res))
            .catch((err) => console.error(err));
          this.$swal({
            title: "Widget Submitted",
            text: "Thanks for the suggestion!",
            showConfirmButton: false,
            type: "success",
            timer: 2500,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.vehicles-container {
  position: absolute;
  bottom: 120px;
  opacity: 0.9;
}
.vehicles-container img {
  width: 16.6vw;
  -webkit-filter: drop-shadow(2px 2px 2px #666) !important;
  filter: drop-shadow(2px 2px 2px #666) !important;
}
.bottom-arrow {
  position: absolute;
  bottom: 130px;
}
.arrow {
  transform: scale(0.8);
  opacity: 0.7;
}
.arrow-widget {
  transform: rotate(160deg) scale(0.8);
}
.arrow-qr {
  transform: rotate(270deg) scale(0.8);
}
.arrow-school {
  transform: rotate(90deg) scale(0.7);
  position: relative;
  left: -25px;
  top: 5px;
}
.arrow-plus {
  transform: rotate(80deg) scale(0.7);
  position: relative;
  left: -25px;
  top: 5px;
}
.smaller {
  font-size: 0.8em;
}
.centered {
  left: 50%;
  transform: translate(-50%, 0%);
}
.system-status {
  position: absolute;
  right: 20px;
  top: 45%;
  height: auto;
  transform: translateY(-50%);
  font-size: 4em;
}
.bird {
  position: absolute;
  right: 0;
  top: 45%;
  /* width: 50%; */
  height: auto;
  transform: translateY(-50%);
}
.bird img {
  max-height: 40vh;
  max-width: 40vh;
  opacity: 0.9;
}
.slider {
  overflow-y: hidden;
  max-width: 500px; /* approximate max height */
  transition-property: all;
  transition-duration: 1.5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slider.closed {
  max-width: 0;
}
/* .shadow {} */
img {
  -webkit-filter: drop-shadow(5px 5px 5px #666);
  filter: drop-shadow(5px 5px 5px #666);
}
p {
  line-height: 1.2em;
  font-size: 0.8em;
  /* width: 300px; */
  /* height: auto; */
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 100px;
}
.login-btn {
  position: absolute;
  left: 0;
  top: 45%;
  /* width: 50%; */
  height: auto;
  transform: translateY(-50%);
  padding: 15px;
}
.login-btn a {
  animation: shadow-pulse 1s 999;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 12px rgba(247, 211, 8, 0);
  }
}
.ongoing {
  animation: shadow-pulse 1s 999;
}
.bird:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.wiggle:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
</style>